// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"190":"daa444ab","623":"1f60d7c9","960":"289fa69f"}[chunkId] + ".js";
};